import { Truck } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A2624] text-zinc-400 py-12 mt-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-[#FFDF00] grid place-items-center">
              <Truck className="w-5 h-5 text-[#0C2E2B]" strokeWidth={2.5} />
            </div>
            <div className="font-display font-black text-xl text-white">HARVEY'S PLACE</div>
          </div>
          <p className="mt-3 text-sm max-w-sm">
            Heavy hauling, precision repair, and reclaimed goods. Family-run since 2022.
          </p>
        </div>
        <div>
          <div className="font-tactical text-[10px] uppercase tracking-widest text-[#FFDF00] mb-3">Services</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#services" className="hover:text-white">Junk Removal</Link></li>
            <li><Link to="/#services" className="hover:text-white">Drywall & Repair</Link></li>
            <li><Link to="/#services" className="hover:text-white">Furniture Assembly</Link></li>
            <li><Link to="/#services" className="hover:text-white">Handyman</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-tactical text-[10px] uppercase tracking-widest text-[#FFDF00] mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/used-goods" className="hover:text-white">Used Goods</Link></li>
            <li><Link to="/merch" className="hover:text-white">Merch</Link></li>
            <li><Link to="/#how" className="hover:text-white">How It Works</Link></li>
            <li><a href="tel:+16129907871" className="hover:text-white">(612) 990-7871</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#0F3B37] mt-10 pt-6 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-wrap justify-between gap-2 text-xs">
        <div>© 2026 Harvey's Place. All rights reserved.</div>
        <div className="flex flex-wrap gap-x-4 gap-y-1" data-testid="footer-legal-links">
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white">Terms</Link>
          <Link to="/terms#privacy" data-testid="footer-privacy-link" className="hover:text-white">Privacy</Link>
          <Link to="/terms#delivery" data-testid="footer-delivery-terms-link" className="hover:text-white">Delivery Terms</Link>
          <Link to="/terms#sms" data-testid="footer-sms-terms-link" className="hover:text-white">SMS Terms</Link>
        </div>
        <div>Licensed · Bonded · Insured · $1M General Liability</div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-3 text-[10px] text-zinc-500">
        Texts from Harvey's Place are sent only with your consent. Msg &amp; data rates may apply. Reply STOP to opt out, HELP for help.
      </div>
    </footer>
  );
}
